import Dexie from 'dexie';

export const db = new Dexie('FlowNoteMobileDB');

db.version(1).stores({
  notes: 'id, updatedAt, createdAt, isPinned, colorTheme'
});

export async function getAllNotes() {
  const notes = await db.notes.orderBy('updatedAt').reverse().toArray();
  return notes;
}

export async function saveNote(note) {
  if (!note.id) return;
  const existing = await db.notes.get(note.id);
  const now = new Date().toISOString();
  const updatedNote = {
    id: note.id,
    content: note.content || '',
    colorTheme: note.colorTheme || 'paper',
    isPinned: note.isPinned ?? (existing?.isPinned || false),
    reminderAt: note.reminderAt ?? (existing?.reminderAt || null),
    cardStates: note.cardStates ?? (existing?.cardStates || {}),
    createdAt: existing?.createdAt || now,
    updatedAt: now
  };
  await db.notes.put(updatedNote);
  return updatedNote;
}

export async function deleteNote(id) {
  if (!id) return;
  await db.notes.delete(id);
}

export async function bulkUpsertNotes(notes) {
  if (!Array.isArray(notes) || notes.length === 0) return;
  await db.notes.bulkPut(notes);
}

/// Persists one cloze card's SM-2 schedule (see services/sm2.js) into a note's
/// cardStates map — called after grading a card in the recall review modal.
export async function updateCardState(noteId, cardId, state) {
  const existing = await db.notes.get(noteId);
  if (!existing) return null;
  const cardStates = { ...(existing.cardStates || {}), [cardId]: state };
  const updated = { ...existing, cardStates, updatedAt: new Date().toISOString() };
  await db.notes.put(updated);
  return updated;
}
